<template>
    <div class="relative" v-click-outside="close">
        <button @click.prevent="toggle" class="btn btn-default btn-md hover:ring-red-500/50" title="Черный список">
            <svg-icon icon="person-x-fill" class="w-5 h-5"></svg-icon>
        </button>
        <div v-if="isOpened" class="translate-y-2 absolute z-30 w-64 card card-white border border-gray-300 dark:border-slate-500 right-0 top-full p-2">
            <div class="font-medium p-2">Не видеть</div>
            <div class="text-sm flex flex-col">
                <label @click="toggleBlock('posts')" class="cursor-pointer p-2 rounded hover:bg-gray-50 dark:hover:bg-slate-700 flex space-x-2 items-start">
                    <div class="shrink-0 rounded border w-5 h-5 border-gray-300 bg-white flex items-center justify-center">
                        <svg-icon v-if="blockData.posts" icon="check" class="text-red-500 h-5 w-5"></svg-icon>
                    </div>
                    <div>Посты пользователя</div>
                </label>
                <label @click="toggleBlock('comments')" class="cursor-pointer p-2 rounded hover:bg-gray-50 dark:hover:bg-slate-700 flex space-x-2 items-start">
                    <div class="shrink-0 rounded border w-5 h-5 border-gray-300 bg-white flex items-center justify-center">
                        <svg-icon v-if="blockData.comments" icon="check" class="text-red-500 h-5 w-5"></svg-icon>
                    </div>
                    <div>Комментарии пользователя</div>
                </label>
            </div>

            <div class="font-medium p-2">Запретить пользователю</div>
            <div class="text-sm flex flex-col">
                <label @click="toggleBlock('disable_rate')" class="cursor-pointer p-2 rounded hover:bg-gray-50 dark:hover:bg-slate-700 flex space-x-2 items-start">
                    <div class="shrink-0 rounded border w-5 h-5 border-gray-300 bg-white flex items-center justify-center">
                        <svg-icon v-if="blockData.disable_rate" icon="check" class="text-red-500 h-5 w-5"></svg-icon>
                    </div>
                    <div>Оценивать мои посты и комментарии</div>
                </label>
                <label @click="toggleBlock('disable_comment')" class="cursor-pointer p-2 rounded hover:bg-gray-50 dark:hover:bg-slate-700 flex space-x-2 items-start">
                    <div class="shrink-0 rounded border w-5 h-5 border-gray-300 bg-white flex items-center justify-center">
                        <svg-icon v-if="blockData.disable_comment" icon="check" class="text-red-500 h-5 w-5"></svg-icon>
                    </div>
                    <div>Комментировать мои посты и отвечать на мои комментарии</div>
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
    props: [
        'block',
        'userid',
    ],
    data() {
        return {
            blockData: this.block || false,
            isOpened: false,
        };
    },
    methods: {
        toggle() {
            this.isOpened = !this.isOpened;
        },
        close() {
            this.isOpened = false;
        },
        toggleBlock(type) {
            let newValue = !this.blockData[type];
            let data = {};
            data[type] = newValue;
            Client.post('/api/v1.1/user/' + this.userid + '/block', data)
                .then(response => {
                    this.blockData = response.data.block;

                    if(type === 'disable_rate' || type === 'disable_comment') {
                        let typeName = type === 'disable_rate' ? 'оценивать' : 'комментировать';

                        if (newValue) {
                            notify({
                                type: 'success',
                                text: 'Теперь пользователь НЕ сможет ' + typeName + ' ваши посты и комментарии',
                            });
                        } else {
                            notify({
                                type: 'success',
                                text: 'Теперь пользователь сможет ' + typeName + ' ваши посты и комментарии',
                            });
                        }
                    } else {
                        let typeName = type === 'posts' ? 'посты' : 'комментарии';

                        if (newValue) {
                            notify({
                                type: 'success',
                                text: 'Теперь вы НЕ будете видеть ' + typeName + ' этого пользователя',
                            });
                        } else {
                            notify({
                                type: 'success',
                                text: 'Теперь вы будете видеть ' + typeName + ' этого пользователя',
                            });
                        }
                    }
                })
                .catch(error => {
                    notify({
                        type: 'error',
                        text: error.response.data.message || 'Что-то пошло не так',
                    });
                });
        },
    },
    computed: {
        isBlocked() {
            return this.blockData.posts || this.blockData.comments;
        }
    }
}
</script>